var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "324px",
    height: "278px",
    viewBox: "0 0 324 278",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.2522906%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "8.68705328%",
    x2: "50%",
    y2: "71.6908137%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.6694733%",
    y1: "-53.106962%",
    x2: "68.6694733%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.6694733%",
    y1: "-53.106962%",
    x2: "68.6694733%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7367F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.9337166,0.0896211054 L35.3243152,0.0896211054 C36.253319,0.0896211054 37.0064254,0.840558824 37.0064254,1.76688744 L37.0064254,6.37936988 C43.174163,14.1367267 46.2580318,21.8940835 46.2580318,29.6514403 C46.2580318,37.1698715 43.6245512,44.6883027 38.3575899,52.2067339 C38.0429248,52.6559016 37.5280792,52.9235108 36.9785951,52.9235108 L9.2794295,52.9235108 C8.72994509,52.9235108 8.21509914,52.6558979 7.90043739,52.2067275 C2.63347913,44.6882984 0,37.1698694 0,29.6514403 C0,22.0404487 2.96859423,14.4294571 8.9057827,6.81846555 L9.25160636,6.37936988 L9.25160636,1.76688744 C9.25160636,0.840558824 10.0047128,0.0896211054 10.9337166,0.0896211054 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    transform: "translate(-993.000000, -1033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner",
    transform: "translate(260.000000, 1033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(733.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chair4",
    transform: "translate(168.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C5C5C5",
    points: "52.4621947 99.1157895 39.7220339 199.831579 46.4015341 199.742896 59.1416949 100.058776"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C3C3C3",
    transform: "translate(60.907119, 149.473684) scale(-1, 1) translate(-60.907119, -149.473684) ",
    points: "63.9374489 99.1157895 51.1972881 199.831579 57.8767884 199.742896 70.6169492 100.058776"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C3C3C3",
    transform: "translate(99.746441, 149.473684) scale(-1, 1) translate(-99.746441, -149.473684) ",
    points: "102.776771 99.1157895 90.0366102 199.831579 96.7161104 199.742896 109.456271 100.058776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,104.425263 C-7.11666536e-16,98.6140649 4.71090699,93.9031579 10.5221053,93.9031579 L53.702859,93.9031579 C59.4245705,93.9031579 64.2066984,89.5494793 64.7421921,83.8528813 L71.6798112,10.0502766 C72.2153049,4.35367859 76.9974328,-2.50165233e-15 82.7191443,0 L111.607538,0 C117.731271,-1.20028471e-14 122.695538,4.96426669 122.695538,11.088 C122.695538,11.3713045 122.68468,11.654505 122.662988,11.9369779 L115.538825,104.708346 C115.09516,110.485771 110.277809,114.947368 104.483374,114.947368 L10.5221053,114.947368 C4.71090699,114.947368 7.11666536e-16,110.236461 0,104.425263 Z",
    id: "Path",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.325295,-4.54747351e-13 C111.576937,-4.55167587e-13 111.826621,0.00838277559 112.074083,0.0248843103 C112.091452,0.280423288 112.100424,0.53866625 112.100424,0.799004785 C112.100424,1.08310107 112.089505,1.36709242 112.067692,1.65035005 L104.948305,94.1001874 C104.503474,99.8766071 99.6865594,104.336842 93.8930372,104.336842 L0.181903832,104.336842 L0.00192970056,104.334358 C0.000645164928,104.266747 8.31754009e-18,104.19898 0,104.131062 C-8.43178012e-15,98.3349579 4.69867087,93.6362871 10.4947751,93.6362871 L53.5500662,93.6362871 C59.2706492,93.6362871 64.0522228,89.2842741 64.5891233,83.588942 L71.52191,10.047345 C72.0588105,4.35201294 76.8403841,-4.57249211e-13 82.5609671,-4.54747351e-13 L111.325295,-4.54747351e-13 Z",
    id: "Combined-Shape",
    fill: "#B2B0B0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom3.4",
    transform: "translate(197.500000, 139.000000) scale(-1, 1) translate(-197.500000, -139.000000) translate(110.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(39.021961, 145.355278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4916603,98.3939364 C69.4916603,98.3939364 63.9591252,111.660452 68.4945528,115.177214 C73.0368005,118.694658 81.8709346,127.392717 81.8709346,127.392717 L53.2480027,121.184441 L60.3137214,96.8450078 L69.4916603,98.3939364 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8480047,107.130037 C67.8480047,107.130037 67.1448888,113.355554 69.1753825,115.480056 C71.2049374,117.60365 82.1947616,125.690376 83.0555858,127.224738 C83.91641,128.760009 82.3768771,130.453255 82.3768771,130.453255 C82.3768771,130.453255 70.5065152,131.484637 65.1679033,128.240686 C61.3134386,125.897378 55.5655362,121.690138 55.5655362,121.690138 L54.0429006,125.82747 L49.7275148,125.651336 C49.7275148,125.651336 49.1558224,120.553439 50.1799873,118.109354 C51.2041522,115.664361 56.4779911,103.223313 56.4779911,103.223313 C56.4779911,103.223313 58.5080417,105.04639 60.6652652,105.965192 C62.8224888,106.883086 65.5246243,109.397988 65.5246243,109.397988 L67.8480047,107.130037 Z",
    id: "Path",
    fill: "#323740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.608068,0.0333021531 C31.2313586,0.462424854 84.7918831,12.2936932 94.5229239,14.303743 C104.253965,16.3137927 112.48093,27.1903148 105.060561,39.7847255 C96.7262867,53.9226156 75.2223327,94.0738958 70.0013398,103.124988 C67.4171669,107.604899 54.3804491,105.093123 57.4427152,97.5739303 C63.1513287,83.5568066 65.8024144,48.344456 80.3567037,35.5055135 C80.3567037,35.5055135 31.4107897,44.0130882 10.2681951,34.2679161 C-5.09769705,27.1839858 -1.62150531,-1.00408495 21.608068,0.0333021531 Z",
    id: "Path",
    fill: "#42474F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(66.991216, 62.481704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7693832,20.8071619 C60.7693832,20.8071619 60.6606397,12.9870213 63.3996164,8.90017851 C66.1385932,4.81333575 66.2473367,0.472212636 68.3202596,0.61431048 C70.3931824,0.756408323 68.340649,10.846715 68.340649,10.846715 C68.340649,10.846715 70.9708822,9.84319147 72.8603004,8.5738294 C74.7497187,7.30446732 80.4791415,1.04672306 81.8180458,2.15563015 C84.0880662,4.04505554 80.4315662,14.7030737 78.440201,16.8338615 C76.4420393,18.9653291 65.526911,25.9743562 65.526911,25.9743562 L38.7917709,53.2771262 L33.7721733,39.4071288 L60.7693832,20.8071619 Z",
    id: "Path",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63115558,18.2277751 C6.10768147,28.5973115 14.304312,47.6465202 17.683407,53.3297643 C21.9181261,60.4471327 28.5957139,63.5828865 36.4141338,58.3021384 C37.7978717,57.3675104 40.5975605,55.1147763 44.8132001,51.5439361 L37.1610471,34.7253393 C33.8523592,37.4526973 32.1980152,38.8163763 32.1980152,38.8163763 C32.1980152,38.8163763 23.7967789,17.3082264 17.0385889,4.84880669 C11.1856243,-5.93065647 -5.18283605,2.46355324 1.63115558,18.2277751 Z",
    id: "Path",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2848176,38.8275224 C33.7890892,43.9232075 34.7170486,46.3235288 35.0686959,46.0284861 C35.4203432,45.7334435 35.2860061,42.6672493 34.6656846,36.8299036 L32.2848176,38.8275224 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65",
    fill: "#FFEDC2",
    points: "35.2595289 35.6562007 41.6585802 57.0592674 48.4551206 51.73171 38.9955499 32.7576025"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(27.224050, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(23.973483, 36.015993) rotate(12.000000) translate(-23.973483, -36.015993) translate(6.473483, 3.515993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8560383,3.50814866 C20.8560383,3.50814866 16.4151516,-1.21588443 11.2869972,0.299831547 C6.15884282,1.81554752 1.52014353,11.1066602 3.7226914,19.8401252 C5.91411528,28.5747212 4.26776637,30.3720889 1.60913537,36.2584963 C-5.53245922,52.0932037 13.4116772,64.826349 13.4116772,64.826349 L34.0580657,60.4434348 L26.6825843,21.8761615 L20.8560383,3.50814866 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3412921,8.42218127 C1.31456235,21.0158366 11.7458058,30.4465191 13.7104188,32.7637772 C20.4642466,51.2283245 15.0915166,53.3922965 7.5753986,59.436756 L11.6169018,64.0487653 L23.2022472,59.2119713 L22.8301894,7.40995338 L13.3412921,8.42218127 Z",
    id: "Path-50",
    fillOpacity: 0.199355332,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.1257969,58.9819856 C18.1257969,58.9819856 25.4565156,57.510493 25.6742426,47.2400037 C25.8919697,36.9695144 24.6844806,33.4636947 24.6844806,33.4636947 L38.5088095,33.2145648 C38.5088095,33.2145648 38.659279,44.6608605 38.6616511,48.8010259 C38.6674187,58.8676442 46.4255713,60.0352847 46.4255713,60.0352847 C46.4255713,60.0352847 44.8128008,67.9984309 32.2862857,68.701899 C22.5058711,69.2520009 18.1257969,58.9819856 18.1257969,58.9819856 Z",
    id: "Path",
    fill: "#F9C7B0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(37.428212, 29.374649) rotate(12.000000) translate(-37.428212, -29.374649) translate(18.928212, 7.374649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.77093172,6.82883838 C1.0474111,1.13896345 10.3105138,-2.30272442 13.0322338,1.79646327 C13.0322338,1.79646327 14.3665166,5.68154301 11.5848853,7.89957343 C7.82150163,10.8909741 2.77093172,6.82883838 2.77093172,6.82883838 Z",
    id: "Path",
    fill: "#FB9934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66683899,22.025379 C-1.50017166,21.7870495 -0.494260559,30.8035164 5.91210565,30.7912759 C5.91210565,30.7912759 9.63302086,43.5997016 22.5515612,43.5997016 C33.0430819,43.5997016 33.7255731,28.6712438 33.8207386,25.6932051 C33.9231136,22.5178786 33.9360907,12.0861029 33.9360907,12.0861029 L4.42676247,12.0724223 L4.66683899,22.025379 Z",
    id: "Path",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90266196,27.5855643 C8.95262324,27.2989006 9.23686744,21.4765933 9.23686744,21.4765933 C12.3787186,20.8536534 12.9318869,20.1451003 15.3061507,16.2546676 C25.8509231,18.4996382 33.0103184,19.1852947 33.9360907,26.8971116 C33.9360907,26.8971116 41.8553238,9.09042149 27.9800291,2.76133562 C15.7756404,-2.79769273 2.89854372,2.42525796 0.651852379,12.1336035 C-0.940024401,18.9865533 0.884455675,24.0194765 0.884455675,24.0194765 C0.884455675,24.0194765 2.48312236,21.4765933 5.10737689,22.1117057 C7.73163142,22.7468181 6.85270068,27.8722281 7.90266196,27.5855643 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.28935,33.9667264 C20.28935,33.9667264 22.4116903,37.3923077 26.5538736,36.1762344",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(23.421612, 35.202057) rotate(-18.000000) translate(-23.421612, -35.202057) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0870522,38.0554716 C23.0592933,38.462955 23.9814822,38.4629138 24.7884704,37.994568",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(23.437761, 38.174211) rotate(2.000000) translate(-23.437761, -38.174211) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9515072,27.0266022 C5.33863596,25.6316197 5.16657964,24.4130574 3.77935793,23.8559183",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(4.455322, 25.441260) rotate(-13.000000) translate(-4.455322, -25.441260) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(23.202247, 57.440444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5569124,1.22269175 C47.7254699,1.21457126 53.6373768,3.80512365 54.3181163,4.80386816 C58.7528062,11.3102083 66.8953674,34.2103127 67.3145595,39.1781173 C67.7868538,44.9084961 59.526487,54.0368731 59.425281,62.3324185 C59.3353202,70.6290939 62.9586357,95.6095225 61.5529978,97.9430331 C60.1586049,100.276544 50.9938455,111.361002 49.0821779,111.406203 C47.1592651,111.451404 45.7239606,105.631753 42.8114787,105.758316 C39.910242,105.884879 33.8603762,113.60072 31.2515122,113.545938 C28.6538933,113.488847 1.7331152,96.434444 3.79096917,91.5753178 C5.86006823,86.7161916 15.4633867,74.6406981 14.4850627,68.0198562 C13.5179838,61.4001443 5.79259761,36.9632598 3.00381191,28.6462438 C0.226271318,20.3292279 -2.0115043,13.7038658 3.17248847,10.1250629 C8.35648123,6.54625998 25.2241367,0 25.2241367,0 L40.3263108,8.44809936 C40.3263108,8.44809936 46.680126,1.26493216 47.5569124,1.22269175 Z",
    id: "Path",
    fill: "#FF9F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1872642,8.21328906 C46.7167329,23.2762121 52.9330017,38.1183601 55.4229061,52.2427214 L48.1810505,48.3409821 L41.5015578,53.4022652 C41.9731165,38.7177479 39.5077908,23.299033 38.3743919,8.21328906 L42.1872642,8.21328906 Z",
    id: "Path",
    fill: "#FFF6E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7309505,19.7792386 L15.558969,20.9973061 C13.5297064,36.123809 15.931032,54.4791497 20.0925138,57.2794932 C24.3406932,60.1381772 40.8750104,57.3328554 40.8750104,59.5967512 C40.8750104,61.8606471 18.0256242,82.6079699 21.7766735,92.5261611 C23.8390585,97.9793363 23.1484509,102.829121 19.7048507,107.075514 L18.7048657,106.403416 C10.9005026,101.109885 2.61512669,94.3517864 3.79096917,91.5753178 C5.86006823,86.7161916 15.4633867,74.6406981 14.4850627,68.0198562 C13.556667,61.6649328 6.39981521,38.889703 3.3614134,29.7194891 L2.3935205,26.8120447 C1.26862451,23.403023 0.332362689,20.3149739 0.106062627,17.6505346 L0.804267669,17.1977937 C11.9643961,10.0437338 16.9398191,10.9043895 15.7309505,19.7792386 L15.7309505,19.7792386 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4366807,1.0667164 L25.2241367,0 L40.6578397,8.01091805 C40.6578397,8.01091805 37.7556736,15.3957923 32.61666,11.7183403 C28.2117913,8.57369143 30.0700953,5.80644483 26.6173206,4.37897627 C23.1760168,2.9515077 22.4366807,1.0667164 22.4366807,1.0667164 Z",
    id: "Path",
    fill: "#FFF6E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6578397,8.01091805 C41.7766294,10.495829 44.0511762,11.9478451 45.227047,11.4964728 C47.1678046,10.7508814 46.3344205,7.78033169 47.0993073,6.279696 C47.6472859,5.21507179 48.0011888,5.05437379 48.4806701,4.05473774 C48.9259027,3.13781389 48.9443381,2.03727745 48.8301759,1.73360551 L47.3118184,1.04354941 C45.9208212,2.35535497 44.901745,3.35908441 44.2545899,4.05473774 C43.4480795,4.9216886 42.2491627,6.24041537 40.6578397,8.01091805 Z",
    id: "Path",
    fill: "#FFF6E1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 66.252514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8685393,39.0957319 C46.8685393,39.0957319 55.9549297,31.0640135 58.7364777,30.1319425 C61.5180258,29.1998716 77.808969,28.0801628 77.7064351,30.1863303 C77.5891923,32.4427442 68.839335,32.3128933 67.9327564,33.4230843 C67.0261777,34.5325954 66.8201371,42.1196936 63.3929952,42.9715425 C59.9727213,43.8233914 49.7187676,45.291862 49.7187676,45.291862 L25.1911722,60.0655827 L24.1432701,46.566863 L46.8685393,39.0957319 Z",
    id: "Path",
    fill: "#FFE0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6951592,5.08897848 C13.12209,18.5825034 4.94883884,39.1364322 1.81155061,47.1498187 C-1.32573762,55.1632053 1.83900853,67.2499402 15.6343965,64.8770712 C17.1876289,64.6101255 19.7058781,63.9409914 23.1891442,62.8696688 L26.4860678,44.3103049 C23.6511487,45.4991055 22.2336891,46.0935058 22.2336891,46.0935058 C22.2336891,46.0935058 35.9449318,21.8210485 39.2930259,15.3142356 C44.8855832,4.44746172 31.1273963,-6.8001353 22.6951592,5.08897848 Z",
    id: "Path",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2336891,46.0935058 C17.5907127,48.3584414 15.561189,48.9927633 16.1451178,47.9964717 C16.7290467,47.00018 19.6342604,44.7924482 24.8607589,41.3732761 L22.2336891,46.0935058 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-64",
    fill: "#FFEDC2",
    points: "22.8978756 45.2359262 20.6205371 65.3045453 29.6266218 62.445439 28.2676026 42.7781332"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(22.147600, 141.142082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.791753,103.055174 C119.791753,103.055174 119.624965,116.190416 130.462249,121.101487 C141.292714,126.011876 149.00907,125.716259 148.026962,129.512973 C147.044855,133.309006 118.85417,133.15575 116.221576,130.18663 C113.977732,127.660936 109.098372,104.141606 107.754795,105.939835 L119.791753,103.055174 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68335,113.409373 C109.68335,113.409373 111.960902,118.987343 112.161365,122.368097 C112.362768,125.749763 117.547493,135.362354 117.547493,135.362354 L121.643322,135.875586 L122.01766,132.390495 C122.01766,132.390495 127.946117,134.913962 131.665491,135.316693 C135.383924,135.720338 148.140098,134.206213 150.676462,132.10032 C153.213768,129.99534 151.931939,127.031016 144.609892,125.22466 C137.288786,123.418304 125.913261,118.140785 123.748645,114.319857 C121.58403,110.498017 121.570854,110.596645 121.570854,110.596645 L121.614146,116.964553 C121.614146,116.964553 119.740342,113.613022 117.52867,113.165543 C115.316997,112.718976 109.68335,113.409373 109.68335,113.409373 Z",
    id: "Path",
    fill: "#323740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38422937,0.185865606 C-2.75516766,18.4539066 -1.56803393,31.6676813 12.9456305,39.8271899 C31.5379043,50.2796719 88.8810807,38.0365814 88.8810807,38.0365814 C88.8810807,38.0365814 87.8639436,46.215229 88.8810807,53.5095971 C91.5375925,72.5606925 104.171718,104.300791 106.844786,108.289012 C110.54133,113.80426 121.80174,109.644908 122.013846,105.052598 C122.225952,100.460288 113.525175,41.8087584 112.202058,30.6243223 C110.885761,19.4392051 106.730061,17.8145262 94.5923229,14.7569996 C91.8038469,14.0545756 58.8284079,5.87012351 55.8075746,6.10867585 C38.50358,7.47515591 23.0291316,5.50088582 9.38422937,0.185865606 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6116445,36.7818068 C41.4361425,38.888405 91.2732234,34.5461182 93.274792,36.5192585 C95.185795,38.4031194 94.866886,71.1789566 99.1539669,90.1480392 C94.9311552,78.6539258 90.3599775,64.1154616 88.8810807,53.5095971 C87.8639436,46.215229 88.8810807,38.0365814 88.8810807,38.0365814 L86.9338899,38.4246444 C76.7736516,40.3957008 29.6708623,48.8583348 12.9456305,39.8271899 C3.13578373,34.5301543 -0.659696246,26.3287121 1.55919061,15.2228634 C4.23459071,28.3242648 11.2522599,35.510609 22.6116445,36.7818068 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    opacity: 0.439941406
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    transform: "translate(120.229826, 32.125623) rotate(13.000000) translate(-120.229826, -32.125623) ",
    cx: 120.229826,
    cy: 32.1256231,
    rx: 3.16373851,
    ry: 5.79352045
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    transform: "translate(105.464760, 28.439076) rotate(-16.000000) translate(-105.464760, -28.439076) ",
    cx: 105.46476,
    cy: 28.4390762,
    rx: 4.21818115,
    ry: 6.32040958
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Example-Task1",
    transform: "translate(135.690627, 81.030805) rotate(-28.000000) translate(-135.690627, -81.030805) translate(118.190627, 51.530805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83913682,2.12371273 L31.8205997,13.3928163 C32.7312263,13.7595571 33.3372694,14.6318662 33.3632448,15.6132248 L34.4002389,54.7911203 C34.4362459,56.1514735 33.3626511,57.2834471 32.002298,57.3194541 C31.717843,57.3269833 31.4342335,57.2851829 31.1640464,57.1959068 L2.38184077,47.685594 C1.37752179,47.3537435 0.697041168,46.4179307 0.690936992,45.3602238 L0.454685626,4.42353755 C0.446832218,3.06273059 1.54361778,1.95321214 2.90442474,1.94535873 C3.22462454,1.94351081 3.54211472,2.00409165 3.83913682,2.12371273 Z",
    id: "Rectangle",
    fill: "#7596FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95258695,2.60468012 L32.9384659,12.2816779 C33.931257,12.6249667 34.5972399,13.5599243 34.5972399,14.6103915 L34.5972399,54.1456757 C34.5972399,55.5065053 33.4940695,56.6096757 32.1332399,56.6096757 C31.8591753,56.6096757 31.5870309,56.5639526 31.3280139,56.4743893 L3.342135,46.7973915 C2.34934386,46.4541027 1.68336097,45.5191451 1.68336097,44.4686778 L1.68336097,4.93339374 C1.68336097,3.57256412 2.78653135,2.46939374 4.14736097,2.46939374 C4.42142556,2.46939374 4.69356993,2.51511684 4.95258695,2.60468012 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "3.32182762 4.36508311 32.9962548 14.2265449 32.9962548 54.6629085 3.72556719 44.3555167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3996517,3.19491209 L24.8742102,7.43989321 C25.4784664,7.66343612 25.8896938,8.22759942 25.9175676,8.87127639 L26.1060151,13.2230119 C26.1251301,13.664426 25.7827891,14.0377586 25.341375,14.0568736 C25.2350945,14.061476 25.1289634,14.0448352 25.0291919,14.007925 L13.5546334,9.76294386 C12.9503772,9.53940095 12.5391498,8.97523765 12.511276,8.33156068 L12.3228284,3.97982522 C12.3037134,3.5384111 12.6460545,3.16507849 13.0874686,3.14596349 C13.1937491,3.14136112 13.2998801,3.15800189 13.3996517,3.19491209 Z",
    id: "Rectangle",
    fill: "#7367F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.133287,20.2485595 C22.5981343,20.2485595 22.9749675,20.6257256 22.9749675,21.0909837 C22.9749675,21.5230091 22.650045,21.8790776 22.2314447,21.9277403 L22.133287,21.9334079 L8.93913365,17.5210442 C8.47428636,17.5210442 8.09745317,17.143878 8.09745317,16.67862 C8.09745317,16.2465946 8.42237566,15.8905261 8.84097593,15.8418633 L8.93913365,15.8361957 L22.133287,20.2485595 Z",
    id: "Path",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.133287,28.6728019 C22.5981343,28.6728019 22.9749675,29.0499681 22.9749675,29.5152261 C22.9749675,29.9472515 22.650045,30.30332 22.2314447,30.3519828 L22.133287,30.3576504 L8.93913365,25.9452866 C8.47428636,25.9452866 8.09745317,25.5681205 8.09745317,25.1028624 C8.09745317,24.670837 8.42237566,24.3147685 8.84097593,24.2661058 L8.93913365,24.2604381 L22.133287,28.6728019 Z",
    id: "Path",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.133287,37.0970443 C22.5981343,37.0970443 22.9749675,37.4742105 22.9749675,37.9394686 C22.9749675,38.3714939 22.650045,38.7275625 22.2314447,38.7762252 L22.133287,38.7818928 L8.93913365,34.3695291 C8.47428636,34.3695291 8.09745317,33.9923629 8.09745317,33.5271048 C8.09745317,33.0950795 8.42237566,32.7390109 8.84097593,32.6903482 L8.93913365,32.6846806 L22.133287,37.0970443 Z",
    id: "Path",
    fill: "#A7C3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5C5C5",
    points: "96.6280936 5.30328358 117.86689 5.30328358 117.86689 140.292896 96.6280936 140.292896"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DBDBDB",
    points: "96.6280936 -2.49210244e-13 109.371371 -2.49210244e-13 109.371371 140.292896 96.6280936 140.292896"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5C5C5",
    points: "1.45900014e-15 5.30328358 105.13204 5.30328358 105.13204 45.7910176 21.238796 45.7910176 21.238796 140.292896 1.45900014e-15 140.292896"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DBDBDB",
    points: "1.41478802e-15 5.30328358 12.7432776 5.30328358 12.7432776 140.292896 1.41478802e-15 140.292896"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5C5C5",
    points: "274.911304 5.30328358 296.1501 5.30328358 296.1501 140.292896 274.911304 140.292896"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5C5C5",
    points: "178.283211 5.30328358 283.415251 5.30328358 283.415251 55.4211071 199.522007 55.4211071 199.522007 140.292896 178.283211 140.292896"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DBDBDB",
    points: "28.9826087 -3.93090058e-13 190.903144 -5.65231444e-13 190.903144 55.3225075 28.9826087 55.3225075"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C3C3C3",
    points: "175.097391 5.30328358 187.840669 5.30328358 187.840669 55.3225075 175.097391 55.3225075"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DBDBDB",
    points: "178.283211 5.30328358 191.026488 5.30328358 191.026488 140.292896 178.283211 140.292896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.536464,0 L299.884941,0 C304.278325,-6.13612206e-15 307.839866,3.5615414 307.839866,7.95492537 C307.839866,12.3483093 304.278325,15.9098507 299.884941,15.9098507 L190.536464,15.9098507 C186.14308,15.9098507 182.581538,12.3483093 182.581538,7.95492537 C182.581538,3.5615414 186.14308,-8.11268773e-17 190.536464,0 Z",
    id: "Rectangle",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C3C3C3",
    points: "16.3626756 3.18197015 178.283211 3.18197015 178.283211 19.0918209 16.3626756 19.0918209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60081166,-2.48689958e-14 L193.690961,-2.48689958e-14 C198.084345,-1.73036653e-14 201.645886,3.5615414 201.645886,7.95492537 C201.645886,12.3483093 198.084345,15.9098507 193.690961,15.9098507 L8.60081166,15.9098507 C4.20742769,15.9098507 0.645886288,12.3483093 0.645886288,7.95492537 C0.645886288,3.5615414 4.20742769,-2.31737658e-14 8.60081166,-2.48689958e-14 Z",
    id: "Rectangle",
    fill: "#DBDBDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cup",
    transform: "translate(210.000000, 129.000000) scale(-1, 1) translate(-210.000000, -129.000000) translate(196.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27395851,1.9077581 L1.88461538,1.9077581 C0.843771048,1.9077581 0,2.69125978 0,3.6577581 L0,6.05479925 C0,8.34514684 1.99951615,10.2018404 4.46604432,10.2018404 L7.27395851,10.2018404 C7.72003466,10.2018404 8.08165082,9.86605397 8.08165082,9.45184041 C8.08165082,9.03762685 7.72003466,8.70184041 7.27395851,8.70184041 L4.46604432,8.70184041 C2.89166844,8.70184041 1.61538462,7.51671972 1.61538462,6.05479925 L1.61538462,3.6577581 C1.61538462,3.51968691 1.73592334,3.4077581 1.88461538,3.4077581 L7.27395851,3.4077581 C7.72003466,3.4077581 8.08165082,3.07197166 8.08165082,2.6577581 C8.08165082,2.24354453 7.72003466,1.9077581 7.27395851,1.9077581 Z",
    id: "Path",
    fill: "#8C81FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1703291,0 C26.3598655,0 27.3241753,0.8954305 27.3241753,2 L27.3241753,7 C27.3241753,10.5999309 24.3976603,13.5651607 20.6332558,13.9562516 L20.6323495,15 L11.2042983,15 L11.2037905,13.9334844 C7.53425152,13.4616777 4.70879068,10.5372311 4.70879068,7 L4.70879068,2 C4.70879068,0.8954305 5.67310045,0 6.86263684,0 L25.1703291,0 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80769231,14 L26.4230769,14 C26.6992193,14 26.9230769,14.2238576 26.9230769,14.5 C26.9230769,14.7809898 26.7044828,15.0134927 26.4240267,15.0308038 L18.4742163,15.5215044 L18.4742163,15.5215044 L12.8203702,15.5215044 L4.80675668,15.0305737 C4.52632784,15.0133941 4.30769231,14.7809546 4.30769231,14.5 C4.30769231,14.2238576 4.53154993,14 4.80769231,14 Z",
    id: "Rectangle",
    fill: "#8C81FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FacingBack-Laptop3",
    transform: "translate(70.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.97004292,43.6617216 L109.500037,43.6617216 C110.298626,43.6617216 110.94601,44.3091056 110.94601,45.1076941 C110.94601,45.9062827 110.298626,46.5536666 109.500037,46.5536666 L6.97004292,46.5536666 C6.17145435,46.5536666 5.5240704,45.9062827 5.5240704,45.1076941 C5.5240704,44.3091056 6.17145435,43.6617216 6.97004292,43.6617216 Z",
    id: "Rectangle",
    fill: "#8C81FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4154994,43.6617216 L109.500037,43.6617216 C110.298626,43.6617216 110.94601,44.3091056 110.94601,45.1076941 C110.94601,45.9062827 110.298626,46.5536666 109.500037,46.5536666 L76.4154994,46.5536666 C75.6169108,46.5536666 74.9695269,45.9062827 74.9695269,45.1076941 C74.9695269,44.3091056 75.6169108,43.6617216 76.4154994,43.6617216 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09733292,0 L68.4289192,0 C70.2380557,1.44402386e-15 71.7661785,1.34263977 71.9989871,3.13673423 L76.7465883,39.7232036 C77.002443,41.6948977 75.6114803,43.5006827 73.6397862,43.7565373 C73.4861691,43.7764712 73.3314255,43.7864694 73.1765204,43.7864694 L8.84493417,43.7864694 C7.03579769,43.7864694 5.50767487,42.4438296 5.27486626,40.6497351 L0.527265022,4.06326577 C0.271410404,2.09157171 1.6623731,0.285786716 3.63406716,0.0299320974 C3.78768428,0.00999814816 3.94242785,-4.1563361e-16 4.09733292,0 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09733292,0 L66.1561588,0 C67.9652953,1.88811307e-15 69.4934181,1.34263977 69.7262267,3.13673423 L74.473828,39.7232036 C74.7296826,41.6948977 73.3387199,43.5006827 71.3670258,43.7565373 C71.2134087,43.7764712 71.0586651,43.7864694 70.90376,43.7864694 L8.84493417,43.7864694 C7.03579769,43.7864694 5.50767487,42.4438296 5.27486626,40.6497351 L0.527265022,4.06326577 C0.271410404,2.09157171 1.6623731,0.285786716 3.63406716,0.0299320974 C3.78768428,0.00999814816 3.94242785,1.36072323e-15 4.09733292,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(36.333169, 22.589966) rotate(-37.000000) translate(-36.333169, -22.589966) ",
    cx: 36.3331694,
    cy: 22.5899656,
    rx: 4.50161101,
    ry: 4.89448879
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    transform: "translate(258.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9716451,81.1560808 C41.7254099,61.3064276 49.6780779,40.9204708 56.9584631,20.0844463 C40.1887192,35.9274673 27.1480679,55.2289164 29.0050447,81.1560808 L32.9716451,81.1560808 Z",
    id: "Path-113",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3059489,83.228885 C26.234098,49.3827906 27.1120363,17.9492339 44.477141,0 C42.0818919,37.1612654 37.6012783,63.3397223 31.9264829,83.228885 L28.3059489,83.228885 Z",
    id: "Rectangle",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5092124,79.7042438 C17.8073788,56.0524833 8.05849441,49.2727491 3.37649908e-14,24.9945966 C26.3734967,38.7023934 28.0267306,50.0214691 33.2034429,79.7042438 L27.5092124,79.7042438 Z",
    id: "Path-112",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2876747,79.7042438 L4.88326225,56.0524833 C13.2888684,58.4541538 27.338624,62.3432258 27.338624,79.7042438 L22.2876747,79.7042438 Z",
    id: "Path-114",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5658509,79.7042438 L44.3719508,79.7042438 C48.0616044,71.9821107 53.2610641,66.666066 65.8399375,73.110154 C57.5945847,60.5212966 40.6768225,56.7114501 38.5658509,79.7042438 Z",
    id: "Path-116",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2251016,79.7042438 L38.0533346,79.7042438 C46.9145923,67.0021913 50.7244942,61.4675277 59.8947003,50.6202636 C47.814428,55.2150015 35.4143534,61.4675277 33.2251016,79.7042438 Z",
    id: "Path-117",
    fill: "#28C76F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(10.153846, 77.781250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#7367F0",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.88738587,-1.3627789 L15.9800474,-1.3627789 C5.5110512,22.9366161 26.1617608,37.3267911 15.9800474,61.5347088 L-5.88738587,61.5347088 L-5.88738587,-1.3627789 Z",
    id: "Rectangle",
    fill: "#857AF9",
    mask: "url(#mask-6)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIllustration);
export default __webpack_public_path__ + "static/media/pricing-Illustration.b00baee8785ed39c0c0a768f6521bf75.svg";
export { ForwardRef as ReactComponent };